import axios from 'axios';
//import { useHistory } from 'react-router-dom';

axios.interceptors.request.use(
    function(successfulReq) {
      const jwt = sessionStorage.getItem("jwt");
      if (jwt && jwt !== "null" && jwt !== "undefined" && jwt.trim() !== "") {
        successfulReq.headers = successfulReq.headers || {};
        successfulReq.headers['x-access-token'] = jwt;
      }
      return successfulReq;
    }, 
    function(error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use( 
    function(successRes) {
        let formatedResponse = successRes;
        formatedResponse["statusCode"] = successRes["status"];
        formatedResponse["body"] = successRes["data"];
        delete formatedResponse["data"];
        return formatedResponse;
    }, 
    function(error) {
      console.log(error ? error.toString() : error);

      const status = error?.response?.status;
      const responseData = error?.response?.data;
      const requestUrl = error?.config?.url || "";

      // Do not redirect if this is an authentication request (login, registration)
      const isAuthRequest = 
        requestUrl.includes('/user/login') || 
        requestUrl.includes('/user/registration') || 
        requestUrl.includes('/login');

      // Extract error message from server response
      let errorMsg = "";
      if (typeof responseData === "string") {
        errorMsg = responseData;
      } else if (responseData && typeof responseData === "object") {
        errorMsg = responseData.message || responseData.error || "";
        if (typeof errorMsg !== "string") {
          errorMsg = JSON.stringify(responseData);
        }
      }
      const lowerMsg = errorMsg.toLowerCase();

      const storedToken = sessionStorage.getItem("jwt");
      const hasStoredToken = Boolean(
        storedToken && 
        storedToken !== "null" && 
        storedToken !== "undefined" && 
        storedToken.trim() !== ""
      );

      // Check if response indicates an invalid or expired token
      const isInvalidToken = (status === 401 || status === 403) && (
        lowerMsg.includes("invalid token") ||
        lowerMsg.includes("jwt expired") ||
        lowerMsg.includes("token expired") ||
        lowerMsg.includes("jwt malformed") ||
        lowerMsg.includes("invalid signature") ||
        lowerMsg.includes("jwt not active") ||
        lowerMsg.includes("jwt must be provided") ||
        lowerMsg.includes("token is invalid") ||
        lowerMsg.includes("unauthorized: token") ||
        lowerMsg.includes("token validation failed")
      );

      // Check if response or client state indicates missing token for a protected resource
      const isMissingToken = (status === 401 || status === 403) && (
        !hasStoredToken ||
        lowerMsg.includes("a token is required for authentication") ||
        lowerMsg.includes("token is required") ||
        lowerMsg.includes("missing token") ||
        lowerMsg.includes("no token provided") ||
        lowerMsg.includes("full authentication is required")
      );

      if (!isAuthRequest && (isInvalidToken || isMissingToken)) {
        sessionStorage.setItem("jwt", "");
        sessionStorage.removeItem("jwt");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }

      return Promise.reject(error);
    }
  );

export default axios;